import {AppState} from '@/store/state';
import {
    ToggleSidebarMenu,
    ToggleTaskSidebar,
    CloseTaskModal,
    OpenTaskModal
} from '@/store/ui/actions';
import {UiState} from '@/store/ui/state';
import {Component, HostBinding, OnInit, Renderer2} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
    @HostBinding('class') class = 'wrapper';
    public ui: Observable<UiState>;
    public selectedTask$ = this.store.select(
        (state: any) => state.ui.selectedTask
    );
    public parentTask$ = this.store.select((state: any) => state.ui.parentTask);
    public isTaskPreviewVisible$ = this.store.select(
        (state: any) => state.ui.taskModalVisible
    );

    constructor(
        private renderer: Renderer2,
        private store: Store<AppState>
    ) {}

    ngOnInit() {
        this.ui = this.store.select('ui');
        this.renderer.removeClass(
            document.querySelector('app-root'),
            'login-page'
        );
        this.renderer.removeClass(
            document.querySelector('app-root'),
            'register-page'
        );
        this.renderer.addClass(
            document.querySelector('app-root'),
            'layout-fixed'
        );

        this.ui.subscribe(
            ({
                menuSidebarCollapsed,
                controlSidebarCollapsed,
                taskSidebarCollapsed,
                darkMode
            }) => {
                if (menuSidebarCollapsed) {
                    this.renderer.removeClass(
                        document.querySelector('app-root'),
                        'sidebar-open'
                    );
                    this.renderer.addClass(
                        document.querySelector('app-root'),
                        'sidebar-collapse'
                    );
                } else {
                    this.renderer.removeClass(
                        document.querySelector('app-root'),
                        'sidebar-collapse'
                    );
                    this.renderer.addClass(
                        document.querySelector('app-root'),
                        'sidebar-open'
                    );
                }

                if (controlSidebarCollapsed) {
                    this.renderer.removeClass(
                        document.querySelector('app-root'),
                        'control-sidebar-slide-open'
                    );
                } else {
                    this.renderer.addClass(
                        document.querySelector('app-root'),
                        'control-sidebar-slide-open'
                    );
                }

                if (taskSidebarCollapsed) {
                    this.renderer.removeClass(
                        document.querySelector('app-root'),
                        'task-sidebar-slide-open'
                    );
                } else {
                    this.renderer.addClass(
                        document.querySelector('app-root'),
                        'task-sidebar-slide-open'
                    );
                }

                if (darkMode) {
                    this.renderer.addClass(
                        document.querySelector('app-root'),
                        'dark-mode'
                    );
                } else {
                    this.renderer.removeClass(
                        document.querySelector('app-root'),
                        'dark-mode'
                    );
                }
            }
        );
    }

    onToggleMenuSidebar() {
        this.store.dispatch(new ToggleSidebarMenu());
    }

    onToggleTaskSidebar() {
        this.store.dispatch(new ToggleTaskSidebar());
    }

    closeTaskPreview() {
        this.store.dispatch(new CloseTaskModal());
    }
    openSubtaskPreview(data: {subtask: any; parent: any}) {
        // Open the subtask in the task preview modal with parent reference
        this.store.dispatch(new OpenTaskModal(data.subtask, data.parent));
    }

    navigateToParentTask(parentTask: any) {
        // Navigate back to the parent task
        this.store.dispatch(new OpenTaskModal(parentTask, null));
    }
}
